import Layout from "../layouts/Layout";
import React, { useEffect, useState } from "react";
import {Link, useParams} from "react-router-dom";
import axios from "axios";
import "./css/notice.css"
import Back_img from "./img/museum_img.jpg"

function NoticeDetail() {
    const { no } = useParams();
    const [notice, setNotice] = useState(null);

    useEffect(() => {
        axios.get(`/notice/${no}`)
            .then(response => {
                setNotice(response.data);
            })
            .catch(error => {
                console.error("Error fetching notice:", error);
            });
    }, [no]);

    if (!notice) {
        return <div>Loading...</div>;
    }

    return (
        <Layout>
            <main className="notice_detail_main">
                <section className="notice_detail_section">
                    {/* 타이틀 */}
                    <p className="notice_tit">
                        공지사항
                    </p>

                    <ul className="notice_detail_box">
                        <li>{notice.title}</li>
                        <li>{notice.regDate}</li>
                        <li>
                            {/*<img src={`/admin/notice/images/${notice.imagePath}`} alt="notice"/>*/}
                            <img src={Back_img} alt="notice"/>
                        </li>
                        <li>{notice.content}</li>
                        <li>{notice.no}</li>
                    </ul>

                    <div className="notice_button">
                        <div>
                            <Link to={'/notice'}>
                                목록
                            </Link>
                        </div>
                    </div>
                </section>
            </main>
        </Layout>
    );
}

export default NoticeDetail;
